import { FLOWERS } from '../../game/flowers';
import { canFulfill, customerFor } from '../../game/orders';
import { totalFlowers } from '../../game/state';
import { Panel } from '../components/Panel';
import { useGameState, useServices } from '../context';

export function OrdersPanel() {
  const state = useGameState();
  const { game } = useServices();
  return (
    <Panel title="Order Board" icon="📜" wide>
      {state.orders.length === 0 ? (
        <p class="empty">
          No orders right now. A new customer will stop by in about {Math.ceil(state.orderTimer)}s!
          🐾
        </p>
      ) : (
        <ul class="orders">
          {state.orders.map((order) => {
            const customer = customerFor(order);
            const ready = canFulfill(state, order);
            return (
              <li key={order.id} class={`order ${ready ? 'ready' : ''}`}>
                <div class="order-who">
                  <span class="order-avatar">{customer.emoji}</span>
                  <b>{customer.name}</b>
                </div>
                <ul class="order-items">
                  {order.items.map((item) => {
                    const have = totalFlowers(state, item.species);
                    const ok = have >= item.qty;
                    return (
                      <li key={item.species} class={ok ? 'ok' : ''}>
                        {FLOWERS[item.species].emoji} {FLOWERS[item.species].name}
                        <span class="qty">
                          {Math.min(have, item.qty)}/{item.qty} {ok ? '✅' : ''}
                        </span>
                      </li>
                    );
                  })}
                </ul>
                <div class="order-reward">
                  🪙{order.reward.toLocaleString()} · ⭐{order.xp} XP
                </div>
                <div class="order-actions">
                  <button
                    class="small-button primary"
                    disabled={!ready}
                    onClick={() => game.dispatch({ type: 'deliverOrder', orderId: order.id })}
                  >
                    Deliver
                  </button>
                  <button
                    class="small-button ghost"
                    aria-label={`Decline ${customer.name}'s order`}
                    title="Decline"
                    onClick={() => game.dispatch({ type: 'discardOrder', orderId: order.id })}
                  >
                    Decline
                  </button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
      <p class="muted center">
        Orders pay much better than the market — and the critters are so grateful!
      </p>
    </Panel>
  );
}
